import React from 'react';
import { connect } from 'react-redux';

// internal components
import Spin from '../../components/loading';
import CommentsFilter from './commentsFilter';
import Comment from './Comment';
import Sort from './Sort';

import * as commentsActions from '../../redux/comments/actions';
import submitForm from '../../utils/submitForm';

class Comments extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pageNumber: 1,
      pageSize: 10,
      commentsList: [],
      sortDirection: 'desc',
      sortBy: 'createdAt',
      selectedSortFiled: {
        label: locales('fields.createdAt'), 
        value: 'createdAt'
      },
      errorText: locales('errors.default'),
      errorFlag: false
    };
  }

  componentDidMount() {
    this.props.actions.initCommentsList();
    this.refreshList();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.replyToCustomerCommentLoading !== nextProps.replyToCustomerCommentLoading) {
      return false;
    }

    return true;
  }

  handlePageChange = () => {
    this.props.actions.savePrevCommentsList(this.props.commentsList);

    this.setState({ pageNumber: this.state.pageNumber + 1 }, () => {
      this.refreshList();
    });
  };

  buildSearchQuery = () => {
    let query = `pageNumber=${this.state.pageNumber}`;
    query += `&pageSize=${this.state.pageSize}`;
    query += `&sort=${this.state.sortBy}-${this.state.sortDirection}`;
    
    if (this.state.filter) {
      query += `&` + this.state.filter;
    }

    return query;
  };

  applyFilters = event => {
    const filter = submitForm(event);
    this.setState({ filter, pageNumber: 1 }, () => this.refreshList());
  };

  refreshList = () => {
    const searchQuery = this.buildSearchQuery();
    return this.props.actions.fetchAllComments(searchQuery);
  };

  onChangeSortBy = selectedListItem => {
    this.setState({ selectedSortFiled: selectedListItem, sortBy: selectedListItem.value });
  };

  setSortDirection = sortDirection => {
    this.setState({ sortDirection });
  };

  handleStarClick = (rate, name, parentIndex) => {
    this.setState({ rate });
  };

  replyToComment = (id, replyText) => {
    return this.props.actions.replyToComment(id, replyText);
  };

  scrollToComment = commentId => {
    this.refs[commentId] && this.refs[commentId].current.scrollIntoView();
  };

  onSort = e => {
    e.preventDefault();

    this.setState(() => ({ pageNumber: 1 }), () => {
      this.refreshList();
    });
  };

  refs = this.props.commentsList.reduce((acc, cmnt) => {
    acc[cmnt.id] = React.createRef();
    return acc;
  }, {});

  render() {
    let { 
      failed, 
      error, 
      commentsList, 
      message, 
      loading, 
      totalRecords, 
      updateCommentStatusLoading,
      updateCommentStatusFailed,
      updateCommentStatusError,
      updateCommentStatusMessage,
      changeCafeAccessToResponseLoading,
      changeCafeAccessToResponseFailed,
      changeCafeAccessToResponseError,
      changeCafeAccessToResponseMessage
    } = this.props;

    let { pageNumber, pageSize, errorFlag, errorText } = this.state;
    
    this.refs = commentsList.reduce((acc, cmnt) => {
      acc[cmnt.id] = React.createRef();
      return acc;
    }, {});

    return (
      <>
        <section className="p-1 col-12">
          <h3 className="text-muted py-4">
            <div className="text-right">{locales('titles.userCommentsManagement')}</div>
          </h3>
        </section>
        <section className="p-1 col-12">
          <Spin spinning={loading || updateCommentStatusLoading || changeCafeAccessToResponseLoading}>
            <article>
              <main className="panel panel-default">
                {errorFlag && <div className="alert alert-danger">{errorText}</div>}
                {(error || updateCommentStatusError || changeCafeAccessToResponseError) && <div className="alert alert-danger">{locales('messages.server.error')}</div>}
                {failed && <div className="alert alert-danger">{message}</div>}
                {updateCommentStatusFailed && <div className="alert alert-danger">{updateCommentStatusMessage}</div>}
                {changeCafeAccessToResponseFailed && <div className="alert alert-danger">{changeCafeAccessToResponseMessage}</div>}

                <div className="panel-heading">
                  <i className="fas fa-list-alt px-1" />
                  {locales('titles.transformedComments')}
                </div>
                <div className="panel-body">
                  <CommentsFilter applyFilters={this.applyFilters} />

                  {/* main body of the chats and comments transformed between user and responsers */}
                  <Sort
                    sortDirection={this.state.sortDirection}
                    selectedSortFiled={this.state.selectedSortFiled}
                    setSortDirection={this.setSortDirection}
                    onChangeSortBy={this.onChangeSortBy}
                    onSort={this.onSort}
                  />

                  {commentsList.map(comment => (
                    <Comment 
                      key={'cmnt_' + comment.id}
                      ref={this.refs[comment.id]}
                      // ref={instance => { this.refs[comment.id] = instance; }}
                      comment={comment}
                      
                      handleStarClick={this.handleStarClick}
                      updateCommentStatus={this.props.actions.updateCommentStatus}
                      changeCafeAccessStatusToResponse={this.props.actions.changeCafeAccessStatusToResponse}
                      refreshList={this.refreshList}
                      replyToComment={this.replyToComment}
                      scrollToComment={this.scrollToComment}
                    />
                  ))}

                  {pageNumber * pageSize < totalRecords && (
                    <footer className="col-12 d-flex justify-content-center py-2">
                      <button onClick={this.handlePageChange} className="btn btn-success w-100">
                        {locales('titles.loadMore')}
                      </button>
                    </footer>
                  )}
                </div>
              </main>
            </article>
          </Spin>
        </section>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    loggedInUserRole: state.authReducer.meInfo.selectedRole.type,
    loading: state.commentsReducer.getCommentsLoading,
    failed: state.commentsReducer.getCommentsFailed,
    error: state.commentsReducer.getCommentsError,
    message: state.commentsReducer.getCommentsMessage,
    comments: state.commentsReducer.comments,
    totalRecords: state.commentsReducer.commentsTotalRecords,
    commentsList: state.commentsReducer.commentsList,

    updateCommentStatusLoading: state.commentsReducer.updateCommentStatusLoading,
    updateCommentStatusFailed: state.commentsReducer.updateCommentStatusFailed,
    updateCommentStatusError: state.commentsReducer.updateCommentStatusError,
    updateCommentStatusMessage: state.commentsReducer.updateCommentStatusMessage,

    changeCafeAccessToResponseLoading: state.commentsReducer.changeCafeAccessToResponseLoading,
    changeCafeAccessToResponseFailed: state.commentsReducer.changeCafeAccessToResponseFailed,
    changeCafeAccessToResponseError: state.commentsReducer.changeCafeAccessToResponseError,
    changeCafeAccessToResponseMessage: state.commentsReducer.changeCafeAccessToResponseMessage
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      initCommentsList: () => dispatch(commentsActions.initCommentsList()),

      changeCafeAccessStatusToResponse: (id, access) =>
        dispatch(commentsActions.changeCafeAccessStatusToResponse(id, access)),
      
      savePrevCommentsList: prevCommentsList =>
        dispatch(commentsActions.savePrevCommentsList(prevCommentsList)),

      fetchAllComments: query => dispatch(commentsActions.fetchAllComments(query)),

      updateCommentStatus: (id, status) => dispatch(commentsActions.updateCommentStatus(id, status))
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Comments);
